module.exports = __webpack_public_path__ + "static/img/img_awards_4.87dbfa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/img_awards_4.png
// module id = YgMl
// module chunks = 15